module.exports = __webpack_public_path__ + "static/img/icon_zanb_pre1@2x.086e1803.png";